export default __webpack_public_path__ + "static/media/af5.957d2d18.jpg";